import React, {useState} from "react";
import "./inputSelectList.css"
import {normalize} from "../../../utils/utils";

function InputSelectList({options, optionsLabel, optionsIcon, result, setResult, label, placeholder, required}) {

    const [search, setSearch] = useState("");

    function toggleGroupToResult(group){
        const index = result.findIndex(x => x.id === group.id)
        if(index >= 0){
            // Delete from result
            setResult(prevValue => {
                const aux = [...prevValue];
                aux.splice(index, 1);
                return aux;
            })
        } else{
            // Add to result
            setResult(prevValue => {
                const aux = [...prevValue];
                aux.push(group);
                return aux;
            })
        }
    }

    function resultContains(group){
        return result.some(y => y.id === group.id)
    }

    return (

        <div className="col-12 d-flex flex-wrap position-relative">
            {label && <label style={{fontWeight: "bold"}}>{label}</label>}
            <input autoComplete="false" className={"form-control"} value={search}
                   placeholder={placeholder} onChange={e => setSearch(e.target.value)}/>
            <ul className="list-group list-group-flush col-12 border rounded"
                style={{maxHeight: "11rem", overflowY: "auto"}}>
                {[...options].sort((a, b) => resultContains(b) - resultContains(a)).filter(x => normalize(x[optionsLabel]).includes(normalize(search))).map(x => {
                    return <button type="button" key={x.id}
                                   className={"list-group-item list-group-item-action d-flex justify-content-between " + (resultContains(x) && " active")}
                                    onClick={() => toggleGroupToResult(x)}>
                        {x[optionsLabel]}
                        {optionsIcon && <img className="image-border" src={x[optionsIcon]}/>}
                    </button>
                })}
            </ul>
        </div>

    );
}

export default InputSelectList;
